import { useEffect, useState } from 'react';

// Subscribes to a CSS media query and re-renders on change. SSR-safe (no
// `window` at module scope) even though this app has no SSR today, so it's
// not a footgun if that ever changes.
export function useMediaQuery(query) {
  const [matches, setMatches] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia(query).matches : false
  );

  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    onChange();
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}

// Below Tailwind's `md` breakpoint (768px) — the one line every mobile-vs-
// desktop layout branch in the app should check, so that threshold lives in
// exactly one place instead of being re-typed as a magic number per call site.
export function useIsMobile() {
  return useMediaQuery('(max-width: 767px)');
}
